angular.module('unergie.main')
.filter('subType', () =>
    function (val) {
        switch (val) {
            case 'CDF': return 'Changement de fournisseur'
            case 'CDF_INTER': return 'Changement de fournisseur avec intervention'
            case 'MES': return 'Mise en service'
            case 'MES_INTER': return 'Mise en service avec intervention'
            case 'FIRST_MES': return '1ère mise en service'
            default: return val
        }
    },
)
